import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClientTxnCatTotalListPageUI from './ClientTxnCatTotalListPageUI.js'
import { getFinancialYearList } from '../../../components/common/GetYearList'

class ClientTxnCatTotalListPageSF extends Component {
  constructor(props) {
    super(props)
    const { financialYearList, financialYear } = getFinancialYearList()
    this.state = {
      errorList: null,
      categoryTotalList: null,
      manualOnly: false,
      allAuto: false,
      financialYear: financialYear,
      financialYearList: financialYearList,
    }
  }

  render() {
    
    return (
      <ClientTxnCatTotalListPageUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        categoryTotalList={this.state.categoryTotalList}
        onRefreshClick={this.onRefreshClick}
        manualOnly={this.state.manualOnly}
        onManualOnly={this.onManualOnly}
        allAuto={this.state.allAuto}
        onAllAuto={this.onAllAuto}
        //
        financialYearList={this.state.financialYearList}
        financialYear={this.state.financialYear}
        onFinancialYearChange={this.onFinancialYearChange}
      //
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getClientTxnCats(context, this.state.financialYear)
  }

  onManualOnly = () => {
    let newChecked = !this.state.manualOnly
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { manualOnly: newChecked })
    this.setState({
      manualOnly: newChecked,
      allAuto: false
    })
  }

  onAllAuto = () => {
    let newChecked = !this.state.allAuto
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { allAuto: newChecked })
    this.setState({
      allAuto: newChecked,
      manualOnly: false
    })
  }

  getClientTxnCats(context, financialYear) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/clientTxnCats/totals`,
      cacheKey: CacheKeys.ClientTxnCats(this.props.match.params.accountId),
      callback: this.getClientTxnCatsCallback,
      ttlInSecs: 60
    })
    cacheManager.getObject2(context)
  }

  getClientTxnCatsCallback = (response) => {
    this.setState({
      categoryTotalList: response.categoryTotalFinancialYears,
      financialYear: response.financialYear,
      errorList: response.errorList
    })
  }

  onFinancialYearChange = (option) => {
    let context = this.props.context
    this.setState({ financialYear: option.value })
    this.getClientTxnCats(context, option.value)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.ClientTxnCats(this.props.match.params.accountId))
    if (noBusy === 'noBusy') {
      this.getClientTxnCats(context, this.state.financialYear)
    }
    else {
      this.setState({
        categoryTotalList: null,
        errorList: null,
      }, () => {
        this.getClientTxnCats(context, this.state.financialYear)
      })
    }
  }
}

export default withRouter(ClientTxnCatTotalListPageSF)
